module.exports = __webpack_public_path__ + "img/tr.220110c6.svg";